import React from "react";

export const InputError = ({
  children,
  absolute = false,
  className = "",
  centered = false,
}: {
  children: any;
  absolute?: Boolean;
  className: string;
  centered?: Boolean;
}) => {
  return (
    <p
      className={`text-red-500 font-bold text-sm ${className} ${absolute && `absolute`} ${centered && `text-center !w-full`}`}
    >
      {children}
    </p>
  );
};
